// extracted by mini-css-extract-plugin
export default {"modalOverlay":"Yi-z","modalContent":"Zi-z","header":"_i-z","close":"aj-z"};